import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.css',
    standalone: false
})
export class AccessDeniedComponent {
  constructor(private authService: AuthService) {}
  goToHome() {
    window.location.href = '/';
  }
  logout() {
    this.authService.logoff();
  }
}
